import { kitchenDashboardTranslations, loginTranslations } from './locales';

export const translations = {
  en: {
    general: {
      english: 'English',
      spanish: 'Español',
    },
    home: {
      orderFlow: {
        reminder: 'The chef defines whether an order must be paid upfront or paid at pickup/delivery.',
        tabs: {
          pickup: 'Pay order at Pickup/delivery',
          upfront: 'Pay order upfront',
        },
        statusLabel: 'Status',
        roles: {
          customer: 'Customer',
          chef: 'Chef',
        },
        statuses: {
          placed: 'PLACED',
          accepted: 'ACCEPTED',
          paid: 'PAID',
          inProgress: 'In-Progress',
          readyOrOut: 'ReadyToPickup / OutForDelivery',
          completed: 'COMPLETED',
        },
        titles: {
          pickup: 'Pay order at Pickup/delivery',
          upfront: 'Pay order upfront',
        },
        upfront: {
          step1: 'Requests order',
          step2: 'Accepts order',
          step3: 'Pays chef directly (Zelle, Cash App, etc.) and clicks Order Paid',
          step4: 'Confirms payment and starts preparation',
          step5: 'Marks as Ready for Pickup or Out for Delivery',
          step6: 'Completes order',
          note2: 'Chef contact/payment info becomes visible to customer for direct payment.',
        },
        pickup: {
          step1: 'Requests order',
          step2: 'Accepts order',
          step3: 'Starts preparation',
          step4: 'Marks as Ready for Pickup or Out for Delivery',
          step5: 'Completes order',
          note5: 'Customer pays at pickup/completion manually. This payment is not reflected as a system status.',
        },
      },
      tiles: {
        chefs: {
          title: 'Why Chefs Love MiaPanza',
          bullet1: '',
          bullet2: 'Manage orders in one place',
          bullet3: 'Track order status',
          bullet4: 'No fees',
          bullet5: 'Keep 100% of your earnings',
          bullet6: 'Payments go directly to you',
          bullet7: 'Easy menu creation',
          bullet8: 'No need to be a professional chef',
          cta: 'For chefs'
        },
        customer: {
          title: 'Why Order Through MiaPanza?',
          description: 'MiaPanza is about home-cooked meals, connecting you with local chefs, reliable delivery, and easy ordering. Nothing beats what is cooked at home.',
          cta: 'See Order Flow'
        },
        payments: {
          title: 'How Payments Work',
          description: 'Payments are handled directly between you and the chef using your preferred method (Zelle, Cash App, Venmo, cash, etc.).\nMiaPanza does not process payments at this time.',
          cta: 'Learn more'
        }
      }
    },
    kitchenDashboard: kitchenDashboardTranslations.en.kitchenDashboard,
    kitchenSettings: kitchenDashboardTranslations.en.kitchenSettings,
    kitchenStatusPanel: kitchenDashboardTranslations.en.kitchenStatusPanel,
    kitchenServices: kitchenDashboardTranslations.en.kitchenServices,
    kitchenPaymentPreferences: kitchenDashboardTranslations.en.kitchenPaymentPreferences,
    kitchenMenus: kitchenDashboardTranslations.en.kitchenMenus,
    menuItems: kitchenDashboardTranslations.en.menuItems,
    login: loginTranslations.en,
  },
  es: {
    general: {
      english: 'Inglés',
      spanish: 'Español',
    },
    home: {
      orderFlow: {
        reminder: 'El chef define si un pedido debe pagarse por adelantado o al recoger/entregar.',
        tabs: {
          pickup: 'Pagar pedido al recoger/entregar',
          upfront: 'Pagar pedido por adelantado',
        },
        statusLabel: 'Estado',
        roles: {
          customer: 'Cliente',
          chef: 'Chef',
        },
        statuses: {
          placed: 'PLACED',
          accepted: 'ACCEPTED',
          paid: 'PAID',
          inProgress: 'In-Progress',
          readyOrOut: 'ReadyToPickup / OutForDelivery',
          completed: 'COMPLETED',
        },
        titles: {
          pickup: 'Pagar pedido al recoger/entregar',
          upfront: 'Pagar pedido por adelantado',
        },
        upfront: {
          step1: 'Solicita pedido',
          step2: 'Acepta pedido',
          step3: 'Paga al chef directamente (Zelle, Cash App, etc.) y hace clic en Pedido pagado',
          step4: 'Confirma el pago e inicia la preparación',
          step5: 'Marca como Listo para recoger o En reparto',
          step6: 'Completa el pedido',
          note2: 'La información de contacto/pago del chef se vuelve visible para que el cliente haga el pago directo.',
        },
        pickup: {
          step1: 'Solicita pedido',
          step2: 'Acepta pedido',
          step3: 'Inicia la preparación',
          step4: 'Marca como Listo para recoger o En reparto',
          step5: 'Completa el pedido',
          note5: 'El cliente paga al recoger/completar de forma manual. Este pago no se refleja como estado del sistema.',
        },
      },
      tiles: {
        chefs: {
          title: 'Por qué MiaPanza para los chefs',
          bullet1: '',
          bullet2: 'Gestiona pedidos en un solo lugar',
          bullet3: 'Haz seguimiento del estado de los pedidos',
          bullet4: 'Sin comisiones',
          bullet5: 'Obten el 100% de tus ganancias',
          bullet6: 'Los pagos directamente a ti',
          bullet7: 'Fácil creación de menús',
          bullet8: 'No necesitas ser un chef profesional',
          cta: 'Para chefs'
        },
        customer: {
          title: '¿Por qué pedir a través de MiaPanza?',
          description: 'MiaPanza se trata de comidas caseras, conectándote con chefs locales. Nada supera lo que se cocina en casa.',
          cta: 'Ver secuencia de pedidos'
        },
        payments: {
          title: 'Cómo funcionan los pagos',
          description: 'Los pagos se manejan directamente entre tú y el chef usando tu método preferido (Zelle, Cash App, Venmo, efectivo, etc.).\nMiaPanza no procesa pagos en este momento.',
          cta: 'Más información'
        }
      }
    },
    kitchenDashboard: kitchenDashboardTranslations.es.kitchenDashboard,
    kitchenSettings: kitchenDashboardTranslations.es.kitchenSettings,
    kitchenStatusPanel: kitchenDashboardTranslations.es.kitchenStatusPanel,
    kitchenServices: kitchenDashboardTranslations.es.kitchenServices,
    kitchenPaymentPreferences: kitchenDashboardTranslations.es.kitchenPaymentPreferences,
    kitchenMenus: kitchenDashboardTranslations.es.kitchenMenus,
    menuItems: kitchenDashboardTranslations.es.menuItems,
    login: loginTranslations.es,
  },
};

export const getNestedValue = (obj, path) => {
  if (!obj || !path) {
    return undefined;
  }

  return path.split('.').reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
};

export const interpolate = (text, params = {}) => {
  if (!text) {
    return '';
  }

  return Object.entries(params).reduce((result, [key, value]) => {
    return result.replace(new RegExp(`\\{${key}\\}`, 'g'), String(value));
  }, text);
};
